<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>运维管理</el-breadcrumb-item>
      <el-breadcrumb-item>供应链采集日志</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 卡片视图区 -->
    <el-card class="box-card">
      <div slot="header" class="flexContainer">
        <span class="cardHeader">供应链采集日志</span>
        <el-button type="primary" size="small" @click="openRunDialog">手动重跑</el-button>
      </div>

      <!-- 搜索条 -->
      <div>
        <el-form :model="queryInfo" :inline="true" size="normal">
          <el-form-item label="任务：">
            <el-select style="width:180px" v-model="queryInfo.taskKey" placeholder="全部任务" clearable @change="getList">
              <el-option v-for="(label, key) in taskLabels" :key="key" :label="label" :value="key"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="状态：">
            <el-select style="width:110px" v-model="queryInfo.status" placeholder="全部状态" clearable @change="getList">
              <el-option label="成功" value="success"></el-option>
              <el-option label="部分失败" value="partial"></el-option>
              <el-option label="失败" value="failed"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="执行时间：">
            <el-date-picker
              v-model="queryInfo.date"
              type="daterange"
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              @change="getList">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="getList">查询</el-button>
          </el-form-item>
        </el-form>
      </div>

      <!-- 表格区域 -->
      <el-table :data="list" style="margin-top:0px">
        <el-table-column label="任务" width="130px">
          <template slot-scope="scope">
            {{ taskLabels[scope.row.taskKey] || scope.row.taskKey }}
          </template>
        </el-table-column>
        <el-table-column label="采集范围" width="200px">
          <template slot-scope="scope">
            <span style="color:#606266;">{{ scope.row.dateRange }}</span>
          </template>
        </el-table-column>
        <el-table-column label="状态" width="90px">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.status==='success'" type="success" size="small" effect="dark">成功</el-tag>
            <el-tag v-else-if="scope.row.status==='partial'" type="warning" size="small" effect="dark">部分失败</el-tag>
            <el-tag v-else type="danger" size="small" effect="dark">失败</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="抓取/新增/更新" width="130px">
          <template slot-scope="scope">
            {{ scope.row.fetchedCount }} / {{ scope.row.insertedCount }} / {{ scope.row.updatedCount }}
          </template>
        </el-table-column>
        <el-table-column label="耗时" width="90px">
          <template slot-scope="scope">
            {{ (scope.row.durationMs / 1000).toFixed(1) }}s
          </template>
        </el-table-column>
        <el-table-column label="来源" width="80px">
          <template slot-scope="scope">
            <el-tag :type="scope.row.triggeredBy==='manual' ? 'primary' : 'info'" size="small">{{ scope.row.triggeredBy==='manual' ? '手动' : '定时' }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="执行时间 / 产物" width="340px">
          <template slot-scope="scope">
            <div>{{ scope.row.createdAt | dateFormat }}</div>
            <div style="font-size:12px;color:#999;word-break:break-all;">{{ scope.row.sourceFile }}</div>
          </template>
        </el-table-column>
        <el-table-column label="错误详情">
          <template slot-scope="scope">
            <span v-if="scope.row.error" style="color:#F56C6C;word-break:break-all">{{ scope.row.error }}</span>
            <span v-else style="color:#999">—</span>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页区域 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryInfo.pagenum"
        :page-sizes="[10,20,50]"
        :page-size="queryInfo.pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </el-card>

    <!-- 手动重跑弹窗 -->
    <el-dialog title="手动重跑采集任务" :visible.sync="runDialogVisible" width="460px">
      <el-form :model="runForm" label-width="90px">
        <el-form-item label="任务：">
          <el-select v-model="runForm.taskKey" placeholder="请选择任务" style="width:100%">
            <el-option v-for="(label, key) in taskLabels" :key="key" :label="label" :value="key"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="日期范围：">
          <el-date-picker
            v-model="runForm.date"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="runPickerOptions"
            style="width:100%">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <span style="font-size:12px;color:#999">支持补采历史日期；任务异步受理，提交后请刷新日志查看结果</span>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="runDialogVisible = false">取 消</el-button>
        <el-button type="primary" :loading="runSubmitting" @click="submitRun">提 交</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data () {
    return {
      list: [],
      total: 0,
      queryInfo: {
        taskKey: '',
        status: '',
        date: '',
        pagenum: 1,
        pagesize: 10
      },
      taskLabels: {
        scm_meituan_delivery_orders: '美团配送单单头',
        scm_meituan_delivery_details: '美团配送单明细',
        scm_shiheng_sale_orders: '食亨销售单单头',
        scm_shiheng_sale_details: '食亨销售单明细'
      },
      runDialogVisible: false,
      runSubmitting: false,
      runForm: {
        taskKey: '',
        date: ''
      }
    }
  },
  computed: {
    // 手动重跑日期选择限制：不允许选择今日之后的日期
    runPickerOptions () {
      return {
        disabledDate (time) {
          return time.getTime() > Date.now()
        }
      }
    }
  },
  created () {
    this.getList()
    // 从采集监控日历页跳转携带 query 时，预开手动重跑对话框并预填任务与日期
    const { taskKey, date } = this.$route.query
    if (taskKey && this.taskLabels[taskKey] && date) {
      this.runForm = { taskKey, date: [date, date] }
      this.runDialogVisible = true
      this.$router.replace({ query: {} }) // 清理 query，防刷新重复弹窗
    }
  },
  methods: {
    // 获取日志列表
    async getList () {
      const params = {
        taskKey: this.queryInfo.taskKey || undefined,
        status: this.queryInfo.status || undefined,
        pagenum: this.queryInfo.pagenum,
        pagesize: this.queryInfo.pagesize
      }
      if (this.queryInfo.date && this.queryInfo.date.length === 2) {
        params.startDate = this.queryInfo.date[0]
        params.endDate = this.queryInfo.date[1]
      }
      const { data: res } = await this.$http.get('scm-collect/logs', { params })
      if (res.meta.status !== 200) return this.$message.error(res.meta.msg)
      this.list = res.data.list
      this.total = res.data.total
    },

    handleSizeChange (newSize) {
      this.queryInfo.pagesize = newSize
      this.getList()
    },

    handleCurrentChange (newPage) {
      this.queryInfo.pagenum = newPage
      this.getList()
    },

    openRunDialog () {
      this.runForm = { taskKey: '', date: '' }
      this.runDialogVisible = true
    },

    // 提交手动重跑
    async submitRun () {
      if (!this.runForm.taskKey) return this.$message.warning('请选择任务')
      if (!this.runForm.date || this.runForm.date.length !== 2) return this.$message.warning('请选择日期范围')
      // 兜底校验：监控页跳转会预填日期（不经选择面板，disabledDate 拦不住），结束日期不允许超过今日
      const now = new Date()
      const pad = n => (n < 10 ? '0' + n : '' + n)
      const today = `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}`
      if (this.runForm.date[1] > today) return this.$message.warning('日期不允许超过今日')
      this.runSubmitting = true
      try {
        const { data: res } = await this.$http.post('scm-collect/run', {
          taskKey: this.runForm.taskKey,
          startDate: this.runForm.date[0],
          endDate: this.runForm.date[1]
        })
        if (res.meta.status !== 200) return this.$message.error(res.meta.msg)
        this.$message.success(res.meta.msg || '任务已受理')
        this.runDialogVisible = false
        // 稍后自动刷新列表查看结果
        setTimeout(() => this.getList(), 3000)
      } finally {
        this.runSubmitting = false
      }
    }
  }
}
</script>

<style lang="less" scoped>
/* 卡片头：标题居左、操作按钮靠右（与财务页 toolbar 规范一致；两类原先无任何定义导致按钮紧贴标题流式排列） */
.flexContainer {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.cardHeader {
  font-size: 16px;
  font-weight: bold;
}
</style>
